import env from '@polleverywhere/core/lib/env'
import { peFetch, apiUrlFor } from '@polleverywhere/fetch'
import { generateCrud, $ajax } from './helpers'

const TOKEN_LOGIN_PATH = '/api/participant_auth_token'
const SESSION_LOGIN_PATH = '/api/sessions'
const SESSION_LOGOUT_PATH = '/api/sessions'

export default function () {
  const crud = generateCrud('/api/profile')

  return {
    create: crud.create,
    read: async (query = {}) => {
      const response = await peFetch(apiUrlFor('/api/profile', query), { retries: 2 })
      return await response.json()
    },
    delete: async () => {
      await $ajax({
        url: env.get('api_url').pathname(SESSION_LOGOUT_PATH).toString(),
        method: 'DELETE'
      })
    },
    authWithToken: async (token) => {
      await $ajax({
        dataType: 'json',
        method: 'POST',
        url: env.get('api_url').pathname(TOKEN_LOGIN_PATH).toString(),
        data: { token }
      })
    },
    authWithPassword: async (login, password, upgradePresenter = false) => {
      await $ajax({
        dataType: 'json',
        method: 'POST',
        url: env.get('api_url').pathname(SESSION_LOGIN_PATH).query({ upgrade_presenter: upgradePresenter }).toString(),
        data: { login, password }
      })
    }
  }
}
